(function () {
  "use strict";
  var doc = document;
  var HIT = "xg-lib__hit";
  function each(list, fn) {
    for (var i = 0; i < list.length; i += 1) fn(list[i], i);
  }
  function norm(s) {
    var out = (s || "").toLowerCase();
    if (out.normalize) out = out.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return out.replace(/\s+/g, " ");
  }
  function tokens(q) {
    var raw = norm(q).split(" ");
    var out = [];
    for (var i = 0; i < raw.length; i += 1) {
      if (raw[i].length) out.push(raw[i]);
    }
    return out;
  }
  function build(root) {
    var input = root.querySelector("[data-xg-lib-input]");
    var form = root.querySelector("[data-xg-lib-form]");
    var count = root.querySelector("[data-xg-lib-count]");
    var empty = root.querySelector("[data-xg-lib-empty]");
    var reset = root.querySelector("[data-xg-lib-reset]");
    var tiles = [].slice.call(root.querySelectorAll("[data-xg-lib-tile]"));
    var groups = [].slice.call(root.querySelectorAll("[data-xg-lib-group]"));
    var entries = [].slice.call(root.querySelectorAll("[data-xg-lib-entry]"));
    if (!entries.length) return;
    var total = entries.length;
    var topic = "";
    var hay = entries.map(function (el) {
      return norm(el.textContent + " " + (el.getAttribute("data-xg-lib-keys") || ""));
    });
    function clearMarks(el) {
      var marks = el.querySelectorAll("." + HIT);
      if (!marks.length) return;
      each(marks, function (m) {
        var text = doc.createTextNode(m.textContent);
        m.parentNode.replaceChild(text, m);
      });
      el.normalize();
    }
    function markOne(node, terms) {
      var value = node.nodeValue;
      var lower = value.toLowerCase();
      var at = -1;
      var len = 0;
      for (var i = 0; i < terms.length; i += 1) {
        var hit = lower.indexOf(terms[i]);
        if (hit !== -1 && (at === -1 || hit < at)) {
          at = hit;
          len = terms[i].length;
        }
      }
      if (at === -1) return null;
      var tail = node.splitText(at);
      var rest = tail.splitText(len);
      var mark = doc.createElement("mark");
      mark.className = HIT;
      mark.appendChild(doc.createTextNode(tail.nodeValue));
      tail.parentNode.replaceChild(mark, tail);
      return rest;
    }
    function highlight(el, terms) {
      clearMarks(el);
      if (!terms.length) return;
      var walker = doc.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var pending = [];
      var node = walker.nextNode();
      while (node) {
        if (node.nodeValue && node.nodeValue.trim()) pending.push(node);
        node = walker.nextNode();
      }
      each(pending, function (text) {
        var cursor = text;
        var guard = 0;
        while (cursor && guard < 40) {
          cursor = markOne(cursor, terms);
          guard += 1;
        }
      });
    }
    function apply() {
      var terms = tokens(input ? input.value : "");
      var shown = 0;
      each(entries, function (el, i) {
        var text = terms.every(function (t) {
          return hay[i].indexOf(t) !== -1;
        });
        var owner = el.closest("[data-xg-lib-group]");
        var inTopic =
          !topic || (owner && owner.getAttribute("data-xg-lib-group") === topic);
        var on = text && inTopic;
        el.hidden = !on;
        if (on) shown += 1;
        highlight(el, on ? terms : []);
      });
      each(groups, function (g) {
        g.hidden = !g.querySelector("[data-xg-lib-entry]:not([hidden])");
      });
      each(tiles, function (t) {
        var mine = t.getAttribute("data-xg-lib-tile") === topic;
        if (mine) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
      if (empty) empty.hidden = shown !== 0;
      if (reset) reset.hidden = !topic && !terms.length;
      if (count) {
        var word = shown === 1 ? " answer" : " answers";
        if (!terms.length && !topic) count.textContent = total + " answers, all of them here.";
        else if (shown === 0) count.textContent = "No answers match that.";
        else count.textContent = shown + word + " of " + total + ".";
      }
    }
    function route(scroll) {
      var id = (location.hash || "").slice(1);
      var target = id ? doc.getElementById(decodeURIComponent(id)) : null;
      if (target && target.hasAttribute("data-xg-lib-entry")) {
        topic = "";
        if (input) input.value = "";
        apply();
        target.open = true;
      } else if (target && target.hasAttribute("data-xg-lib-group")) {
        topic = target.getAttribute("data-xg-lib-group");
        if (input) input.value = "";
        apply();
      } else if (target === root || !target) {
        topic = "";
        if (input) input.value = "";
        apply();
        if (!target) return;
      } else {
        return;
      }
      if (scroll && target) target.scrollIntoView({ block: "start" });
    }
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        apply();
      });
    }
    if (input) {
      var timer = 0;
      input.addEventListener("input", function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          if (topic) topic = "";
          apply();
        }, 180);
      });
      input.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || !input.value) return;
        input.value = "";
        apply();
      });
    }
    if (reset) {
      reset.addEventListener("click", function () {
        topic = "";
        if (input) input.value = "";
        apply();
      });
    }
    route(true);
    root.setAttribute("data-xg-lib-ready", "");
    return route;
  }
  var routers = [];
  function prune() {
    for (var i = routers.length - 1; i >= 0; i -= 1) {
      if (!doc.contains(routers[i].root)) routers.splice(i, 1);
    }
  }
  function init(scope) {
    prune();
    each((scope || doc).querySelectorAll("[data-xg-library]"), function (root) {
      if (root.hasAttribute("data-xg-lib-ready")) return;
      var route = build(root);
      if (route) routers.push({ root: root, route: route });
    });
  }
  window.addEventListener("hashchange", function () {
    prune();
    for (var i = 0; i < routers.length; i += 1) routers[i].route(true);
  });
  init(doc);
  doc.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  doc.addEventListener("shopify:section:unload", prune);
  window.XG = window.XG || {};
  window.XG.library = {
    init: init,
    live: function () { prune(); return routers.length; }
  };
})();
